const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 50,
    style: {
      fill: "#E94C3D"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.6,51.3l0.5,0.1L44,51.9c-1.2,3.9-0.1,8.1,2.8,11L58,74.1l4.4-4.4L51.1,58.4    c-1.9-1.9-1.9-4.9,0-6.8c0.9-0.9,2.1-1.4,3.4-1.4c1.3,0,2.5,0.5,3.4,1.4l0,0l4.4-4.4l0,0c-2.1-2.1-4.8-3.2-7.8-3.2    c-0.9,0-1.7,0.1-2.5,0.3l-0.5,0.1l-0.1-0.5c-0.5-3.1-3.2-5.4-6.4-5.4c-3.6,0-6.5,2.9-6.5,6.5C38.6,48,40.6,50.6,43.6,51.3z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5,44.6l-0.6-0.2c-1-0.3-2.1-0.4-3.1-0.4c-2.9,0-5.7,1.1-7.8,3.2L53.8,58.5l4.4,4.4l11.2-11.2    c0.9-0.9,2.1-1.4,3.4-1.4s2.5,0.5,3.4,1.4c1.9,1.9,1.9,4.9,0,6.7l0,0l4.4,4.4l0,0c2.8-2.8,3.9-7,2.8-10.9l-0.2-0.6l0.6-0.1    c3.2-0.4,5.6-3.2,5.6-6.4c0-3.6-2.9-6.5-6.5-6.5c-3.2,0-6,2.4-6.4,5.6L76.5,44.6z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,89.5c3,0,5.6-2.1,6.3-5l0.1-0.5l0.5,0.1c0.9,0.2,1.8,0.3,2.7,0.3c2.9,0,5.7-1.1,7.8-3.2    L73.5,70l-4.4-4.4L57.9,76.8c-0.9,0.9-2.1,1.4-3.4,1.4c-1.3,0-2.5-0.5-3.4-1.4c-1.9-1.9-1.9-4.9,0-6.7l0,0l-4.4-4.4l0,0    c-2.7,2.7-3.8,6.8-2.9,10.5l0.1,0.5l-0.5,0.1c-2.9,0.7-5,3.3-5,6.3C38.5,86.6,41.4,89.5,45,89.5z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,84.4c1.1,0,2.2-0.2,3.2-0.5l0.5-0.2l0.1,0.5c0.6,3,3.3,5.2,6.3,5.2c3.6,0,6.5-2.9,6.5-6.5    c0-3.2-2.4-6-5.5-6.4l-0.5-0.1l0.1-0.5c0.9-3.8-0.2-7.7-2.9-10.4L69.4,54.4L65,58.8L76.2,70c1.9,1.9,1.9,4.9,0,6.7    c-0.9,0.9-2.1,1.4-3.4,1.4s-2.5-0.5-3.4-1.4l0,0L65,81.2l0,0C67.1,83.3,69.9,84.4,72.8,84.4z",
    style: {
      fill: "#FFFFFF"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20);
export default __webpack_public_path__ + "static/media/icon20.35a786ae20d2dfaea46def69639cf17c.svg";
export { ForwardRef as ReactComponent };